'use strict';

var cov_yc1a4c79l = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.meetings.factory.js',
        hash = '609f2e2e34c0e2c67454c4dee6b3b08cc7d6014d',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.meetings.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 47,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 45,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 42,
                    column: 20
                },
                end: {
                    line: 42,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 47,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 46,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 41,
                        column: 24
                    },
                    end: {
                        line: 41,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 41
                    },
                    end: {
                        line: 43,
                        column: 17
                    }
                },
                line: 41
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_yc1a4c79l.s[0]++;
(function () {
    'use strict';

    cov_yc1a4c79l.f[0]++;
    cov_yc1a4c79l.s[1]++;
    angular.module('app').factory('MeetingsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_yc1a4c79l.f[1]++;
        cov_yc1a4c79l.s[2]++;

        return restmod.model('/meetings').mix('MixinContainable', {
            $config: {
                contains: {
                    meetingUsers: {
                        type: 'hasMany',
                        table: 'MeetingUsersTable',
                        foreignKey: 'meeting'
                    },
                    topics: {
                        type: 'hasMany',
                        table: 'TopicsTable',
                        foreignKey: 'meeting'
                    },
                    decisions: {
                        type: 'hasMany',
                        table: 'DecisionsTable',
                        foreignKey: 'meeting'
                    },
                    project: {
                        type: 'belongsTo',
                        table: 'ProjectsTable',
                        foreignKey: 'project'
                    },
                    meetingFiles: {
                        type: 'hasMany',
                        table: 'MeetingFilesTable',
                        foreignKey: 'meeting'
                    }
                }
            },
            scheduleDate: {
                decode: function decode(value) {
                    cov_yc1a4c79l.f[2]++;
                    cov_yc1a4c79l.s[3]++;

                    return new Date(value);
                }
            }
        });
    }
})();